import { Client } from "../../clients/client";

import { MigrateExportForm } from "./forms/MigrateExportForm";

export class MigrateUseCase {
  constructor(private client: Client) {}

  public migrateCustomers(form: MigrateExportForm): Promise<any> {
    return this.client.migrates.postCustomers({ shopId: form.shop!.id });
  }

  public migrateCleanCustomers(form: MigrateExportForm): Promise<any> {
    return this.client.migrates.postCleanCustomers({ shopId: form.shop!.id });
  }

  public migrateCategories(form: MigrateExportForm): Promise<any> {
    return this.client.migrates.postCategories({ shopId: form.shop!.id });
  }

  public migrateProducts(form: MigrateExportForm): Promise<any> {
    return this.client.migrates.postItems({ shopId: form.shop!.id });
  }

  public migrateInventories(form: MigrateExportForm): Promise<any> {
    return this.client.migrates.postInventories({ shopId: form.shop!.id });
  }
}
